module.exports = __webpack_public_path__ + "static/media/icon-recebimento.770c13ea.svg";